<div class="card">
  <div class="row mb-2">
    <div class="col align-self-center">
      <h3 class="card-title">
        {{ 'customer' | translate }}
      </h3>
    </div>
    <div class="col d-flex flex-row-reverse" [ngClass]="{ invisible: !canCreateOrEdit }">
      <btn
        [label]="'recalculate'"
        [title]="'recalculate' | translate"
        [icon]="'far-sync'"
        [classes]="['btn-third', 'btn-sm']"
        (onEvent)="onRecalculatedPricesByPriceLevel()"
      ></btn>
    </div>
  </div>
  <div class="box-border">
    <div class="d-flex justify-content-between align-items-center">
      <div
        class="align-self-center"
        [ngClass]="{
          'flex-gap-10':
            order.customer &&
            order.customer.firstName &&
            order.customer.firstName.length &&
            order.customer.lastName &&
            order.customer.lastName.length
        }"
      >
        <div>
          @if (
            order.customer &&
            order.customer.firstName &&
            order.customer.firstName.length &&
            order.customer.lastName &&
            order.customer.lastName.length
          ) {
            <div class="circle">
              <span class="initials"> {{ order.customer.firstName[0] }}{{ order.customer.lastName[0] }} </span>
            </div>
          }
        </div>
        <div class="my-auto" data-cy="customer-details">
          <div class="card-subheading">
            @if (order.customer?.name) {
              <a class="link" [routerLink]="['/customer', order.customer.id]" data-cy="customer-link">
                {{ order.customer.name }}
              </a>
            }
          </div>
          <div class="card-subheading">
            @if (order.customer) {
              <a class="link" [routerLink]="['/customer', order.customer.id]" data-cy="customer-link">
                {{ order.customer.firstName + ' ' + (order.customer.lastName !== null ? order.customer.lastName : '') }}
              </a>
            }
            {{ !order.customer ? 'Nevybraný zákazník' : '' }}
          </div>
          @if (order.customer?.email || 0) {
            <div class="product-details" data-cy="customer-email">
              {{ order.customer.email }}
            </div>
          }
          @if (order.customer?.phone || 0) {
            <div class="product-details">
              {{ order.customer.phone }}
            </div>
          }
        </div>
      </div>
      <div class="d-flex align-items-center">
        @if (canCreateOrEdit) {
          <modal-customer-search
            [(customer)]="order.customer"
            [btnTitle]="'customer.add' | translate"
            [dataCyAttribute]="'modal-customer-search'"
          >
          </modal-customer-search>
        }
        @if (order.customer && !readonly) {
          <btn
            [title]="'delete' | translate"
            [icon]="'far-trash-alt'"
            [classes]="['ms-1 btn-trash', 'btn-sm']"
            (onEvent)="order.customer = null"
            [dataCyAttribute]="'order-customer-delete'"
          ></btn>
        }
      </div>
    </div>
  </div>
  <div class="box-border mt-2">
    <div class="d-flex justify-content-between align-items-center">
      <div class="card-title w-auto">
        {{ 'address.invoice' | translate }}
      </div>
      @if (canCreateOrEdit) {
        <div class="align-self-center w-auto">
          <modal-address
            [isModalOnOrderPage]="true"
            [(address)]="order.invoiceAddress"
            [customer]="order.customer"
            [isCreating]="!order.invoiceAddress?.country"
            [dataCyAttribute]="'modal-address-invoice'"
            (editedAddressChange)="isEditedAddress()"
            (onEditedAddressChange)="onEditedAddress($event, true)"
          >
          </modal-address>
        </div>
      }
    </div>
    @if (order.invoiceAddress) {
      <div class="">
        <div data-cy="order-invoice-address">
          @if (!order.invoiceAddress?.country) {
            <div class="d-flex justify-content-center align-items-center card-subheading">
              {{ 'no.address' | translate }}
            </div>
          }
          @if (order.invoiceAddress?.companyName) {
            <div>
              {{ order.invoiceAddress.companyName }}
            </div>
          }
          @if (order.invoiceAddress?.firstName) {
            <div>
              {{ order.invoiceAddress.firstName + ' ' + order.invoiceAddress.lastName }}
            </div>
          }
          <div class="flex-gap-5">
            @if (order.invoiceAddress?.ic) {
              <div data-cy="invoiceAddress-ic">
                {{ 'company.ic' | translate }}: {{ order.invoiceAddress.ic }}
                @if (order.invoiceAddress && order.invoiceAddress.dic) {
                  <span>,</span>
                }
              </div>
            }
            @if (order.invoiceAddress?.dic) {
              <div data-cy="invoiceAddress-dic">{{ 'company.dic' | translate }}: {{ order.invoiceAddress.dic }}</div>
            }
          </div>
          @if (order.invoiceAddress?.phone) {
            <div>
              {{ order.invoiceAddress.phone }}
            </div>
          }
          @if (order.invoiceAddress?.email) {
            <div>
              {{ order.invoiceAddress.email }}
            </div>
          }
          @if (order.invoiceAddress?.street) {
            <div>
              {{ order.invoiceAddress.street }}
            </div>
          }
          <div class="flex-gap-5">
            @if (order.invoiceAddress?.city || order.invoiceAddress?.zip || order.invoiceAddress?.country) {
              <div>
                <span>{{ order.invoiceAddress.city + ', ' }}</span>
                <span>{{ order.invoiceAddress.zip ? order.invoiceAddress.zip + ', ' : '' }}</span>
                <span>{{ order.invoiceAddress.country }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <div class="box-border mt-2">
    <div class="d-flex justify-content-between align-items-center">
      <div class="card-title">
        {{ 'address.shipping' | translate }}
      </div>
      @if (canCreateOrEdit && !isShippingAddressSameAsInvoice) {
        <div>
          <modal-address
            [isModalOnOrderPage]="true"
            [(address)]="order.shippingAddress"
            [customer]="order.customer"
            [isCreating]="!order.shippingAddress?.country"
            (editedAddressChange)="isEditedAddress()"
            (onEditedAddressChange)="onEditedAddress($event, false)"
            [dataCyAttribute]="'modal-address-shipping'"
          >
          </modal-address>
        </div>
      }
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <form-row-toggle
          [noMarginBottom]="true"
          [cursorPointer]="true"
          [label]="'address.same'"
          [model]="isShippingAddressSameAsInvoice"
          (modelChange)="relationInvoiceShippingChanged($event)"
          [classesString]="'text-nowrap'"
          [inputDisabled]="!canCreateOrEdit"
          [dataCyAttribute]="'toggle-isShippingAddressSameAsInvoice'"
        ></form-row-toggle>
      </div>
    </div>
    @if (order.shippingAddress) {
      <div class="row mt-2">
        <div class="col-12">
          <div class="d-flex align-items-center">
            @if (!order.shippingAddress?.country) {
              <div class="d-flex justify-content-center align-items-center card-subheading">
                {{ 'no.address' | translate }}
              </div>
            }
            @if (!isShippingAddressSameAsInvoice) {
              <div data-cy="order-shipping-address">
                @if (order.shippingAddress && order.shippingAddress.companyName) {
                  <div>
                    {{ order.shippingAddress.companyName }}
                  </div>
                }
                @if (order.shippingAddress && order.shippingAddress.firstName) {
                  <div>
                    {{ order.shippingAddress.firstName + ' ' + order.shippingAddress.lastName }}
                  </div>
                }
                @if (order.shippingAddress && order.shippingAddress.phone) {
                  <div>
                    {{ order.shippingAddress.phone }}
                  </div>
                }
                @if (order.shippingAddress && order.shippingAddress.email) {
                  <div>
                    {{ order.shippingAddress.email }}
                  </div>
                }
                @if (order.shippingAddress.street) {
                  <div>
                    {{ order.shippingAddress.street }}
                  </div>
                }
                <div class="flex-gap-5">
                  @if (order.shippingAddress?.city || order.shippingAddress?.zip || order.shippingAddress?.country) {
                    <div>
                      <span>{{ order.shippingAddress.city + ', ' }}</span>
                      <span>{{ order.shippingAddress.zip ? order.shippingAddress.zip + ', ' : '' }}</span>
                      <span>{{ order.shippingAddress.country }}</span>
                    </div>
                  }
                </div>
                @if (order.shippingAddress?.branchId) {
                  <div class="flex-gap-5">
                    <div>{{ 'branch' | translate }}:</div>
                    <div>
                      {{ order.shippingAddress?.branchId }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
